import React from 'react';
import { FormInputText } from '../../common/formInputsV2/FormInputText';
import { FormInputDate } from '../../common/formInputsV2/FormInputDate';
import {
  SurfaceCard, SurfaceCardHeader, SurfaceCardHeading, SurfaceCardCloseButton,
} from '../../common/formInputsV2/Card.styles';

function InsuredPerson({
  isValid, error_name, error_surname, error_birth_date, name, surname, birth_date, values, register, remove, index,
}) {
  return (
    <SurfaceCard>
      <SurfaceCardHeader>
        <SurfaceCardHeading>Inserisci i dati della persona che viaggia con te</SurfaceCardHeading>
        {index !== 0 && (
          <SurfaceCardCloseButton type="button" aria-label="Rimuovi" onClick={() => remove(index)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </SurfaceCardCloseButton>
        )}
      </SurfaceCardHeader>
      <FormInputText
        placeholder="Nome"
        label="Nome"
        value={values.name}
        error={error_name}
        registration={register(name)}
        valid={isValid('name')}
      />
      <FormInputText
        placeholder="Cognome"
        label="Cognome"
        value={values.surname}
        error={error_surname}
        valid={isValid('surname')}
        registration={register(surname)}
      />
      <FormInputDate
        label="Data di nascita"
        value={values.birth_date}
        error={error_birth_date}
        valid={isValid('birth_date')}
        registration={register(birth_date)}
      />
    </SurfaceCard>
  );
}

export default InsuredPerson;
